/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Delete_DeletingInputs */

const he_notifications_delete_deleting = /** @type {(inputs: Notifications_Delete_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מבטל...`)
};

const en_notifications_delete_deleting = /** @type {(inputs: Notifications_Delete_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removing...`)
};

/**
* | output |
* | --- |
* | "Removing..." |
*
* @param {Notifications_Delete_DeletingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_delete_deleting = /** @type {((inputs?: Notifications_Delete_DeletingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Delete_DeletingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_delete_deleting(inputs)
	return en_notifications_delete_deleting(inputs)
});